// Pure state for the brand filter, kept apart from React so it can be tested.
// The choice is remembered PER TENANT, so it follows a user from Leads to Customers
// to Analytics, and switching tenant never carries one business's brand into another.

export const storageKey = (tenantId) => `brandFilter:${tenantId ?? "none"}`;

/** The remembered brand if it is still one of this tenant's brands, else "" (All). */
export const resolveStoredBrand = (stored, brands) => {
  const b = String(stored || "").trim().toLowerCase();
  return b && Array.isArray(brands) && brands.includes(b) ? b : "";
};

/** Request params for a list/aggregate call: {brand} only when one is chosen. */
export const brandParams = (brand) => (brand ? { brand } : {});
